var offCanvas = {

    init: function () {
        if ($('.offcanvas').size() > 0) {
            this.triggerOffcanvas();
        }
        this.getUserProductLists();
    },

    getUserProductLists: function () {
        if ($("#page-product-overview").length > 0 || $("#page-product").length > 0 || $(".dt-zoneplanner-").length > 0 || $(".gt-main").length > 0)
        {
            $.ajax({
                url: '/Umbraco/Api/UserProductList/GetAllListsForUser',
                type: 'GET',
                dataType: 'text',
            }).done(function (data) {
                var renderedLists = "";
                $.each(JSON.parse(data), function (i, item) {
                    if (item.name !== undefined) {
                        var formattedListName = item.name.toLowerCase().replace(/\s+/g, '_');
                        renderedLists = renderedLists + '<li class="offcanvas-search__item list-' + formattedListName + '" data-list-name="' + formattedListName + '"><div class="offcanvas-search__product-list" data-id="' + item.id + '" >' + item.name + '</div></li>';
                    }
                });
                $(".offcanvas-search__list").replaceWith('<ul class="offcanvas-search__list">' + renderedLists + '</ul>');
            }).fail(function (error) {
                //console.log("error", error); 
            });
        }
    },

    triggerOffcanvas: function () {
        var $offcanvas = $('.offcanvas');
        var $overlay = $('.offcanvas-overlay');
        var $body = $('body');
        var $close = $('.offcanvas__close', $offcanvas);
        var $stage = $('.offcanvas__stage', $offcanvas);

        if (Cookies.get('offcanvasSuccess')) {

            var viewId = Cookies.get('offcanvasSuccess');

            if ($('#user-status').val() !== "true") {
                viewId = Cookies.get('offcanvasFailure');
            }

            var viewHtml = $(viewId).html();
            var viewParent = $(viewId).parent();
            var successView = viewId;

            if(!viewHtml){
                // Removes cookies when redirect to success page
                Cookies.remove('offcanvasSuccess');
                Cookies.remove('offcanvasFailure');
            }
            else {
                if (viewId === '#offcanvas__view--download' || viewId === "#offcanvas__view--marketing") {
                    $offcanvas.addClass('offcanvas--active offcanvas--wide');
                } else {
                    $offcanvas.addClass('offcanvas--active');
                }

                $overlay.addClass('offcanvas-overlay--active')

                $stage.html(viewHtml);

                $stage.attr('data-success-view', Cookies.get('offcanvasSuccess'));
                $stage.attr('data-failure-view', Cookies.get('offcanvasFailure'));
            }
        }

        $('.offcanvas-trigger').click(function (e) {
            e.preventDefault();

            var $trigger = $(this);
            var viewId = $trigger.data('offcanvas-id');
            var viewHtml = $(viewId).html();
            var viewParent = $(viewId).parent();
            var successView = $trigger.data('offcanvas-success');

            if (viewId === 'offcanvas__view--download' || viewId === "#offcanvas__view--marketing") {
               $offcanvas.addClass('offcanvas--active offcanvas--wide');
            } else {
                $offcanvas.addClass('offcanvas--active');
            }

            $overlay.addClass('offcanvas-overlay--active')
            var clone = $(viewId).clone();

            if ($($trigger.attr("data-marketing-id")).size() > 0) {
                var downloadsId = $trigger.attr("data-marketing-id"); 
                clone = $(downloadsId).clone();
                if(clone.find("input[type=radio]").first()[0] != null)
                {
                clone.find("input[type=radio]").first()[0].checked = true;                      
                }
                viewHtml = clone.html();
            }

            $stage.html(viewHtml);
            $stage.attr('data-success-view', successView);
            $stage.attr('data-failure-view', viewId);
        });

        $close.click(function (e) {
            $offcanvas.removeClass('offcanvas--active offcanvas--wide');
            $overlay.removeClass('offcanvas-overlay--active')

            Cookies.remove('offcanvasSuccess');
            Cookies.remove('offcanvasFailure');
        });

        $('.offcanvas-overlay').click(function (e) {
            $offcanvas.removeClass('offcanvas--active offcanvas--wide');
            $overlay.removeClass('offcanvas-overlay--active');
            $('.offcanvas-search__add-confirm').removeClass('offcanvas-search__add-confirm--active');

            Cookies.remove('offcanvasSuccess');
            Cookies.remove('offcanvasFailure');
        });

        $('body').on('submit', '.offcanvas__stage form', function () {
            var $stage = $(this).closest('.offcanvas__stage')
            var successView = $stage.data('success-view');
            var failureView = $stage.data('failure-view');

            Cookies.set('offcanvasSuccess', successView);
            Cookies.set('offcanvasFailure', failureView);
        });
    }
}


$(document).ready(function () {
    offCanvas.init();
});